/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Click_DownloadInputs */

const en_claims_click_download = /** @type {(inputs: Claims_Click_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to Download`)
};

const fr_claims_click_download = /** @type {(inputs: Claims_Click_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez pour télécharger`)
};

/**
* | output |
* | --- |
* | "Click to Download" |
*
* @param {Claims_Click_DownloadInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_click_download = /** @type {((inputs?: Claims_Click_DownloadInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Click_DownloadInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_click_download(inputs)
	return fr_claims_click_download(inputs)
});